export const VERSION = '2026.0.0';
